import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { downloadUserSessions, getUserSessions } from "../../redux/userSpeaker/userSpeakerSlice";
import { formatDateTime, getImageUrlHelper, truncateText } from "../../helper/helper";
import { useLocationFilter } from "../../context/LocationContext";
import { toast } from "react-toastify";
import Avatar from "../../components/Avtar/Avatar";
import PaginationHelper from "../../helper/PaginationHelper";

const UserSessionLayer = () => {
    const dispatch = useDispatch();
    const { selectedLocation } = useLocationFilter();

    const {
        userSessions = [],
        sessionTotal = 0,
    } = useSelector((state) => state.speaker);


    const [entries, setEntries] = useState(50);
    const [page, setPage] = useState(1);

    useEffect(() => {
        dispatch(
            getUserSessions({
                page,
                limit: entries,
                locationId: selectedLocation?.value || ""
            })
        );
    }, [page, entries, selectedLocation]);

    const totalPages = Math.ceil(sessionTotal / entries);

    return (
        <div className="card">

            <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">

                <div className="d-flex align-items-center gap-2">
                    <select
                        className="form-select w-auto"
                        value={entries}
                        onChange={(e) => {
                            setEntries(Number(e.target.value));
                            setPage(1);
                        }}
                    >
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                        <option value="200">200</option>
                    </select>
                </div>

                <div>
                    <button
                        className="btn btn-success d-flex align-items-center gap-1"
                        onClick={() => {
                            const params = {};

                            if (!selectedLocation?.value) {
                                return toast.error(
                                    "Please select location from header to download User Sessions"
                                );
                            }

                            params.locationId = selectedLocation.value;

                            dispatch(downloadUserSessions(params));
                        }}
                    >
                        <i className="ri-file-excel-2-line"></i>
                        Download
                    </button>
                </div>

            </div>

            {/* TABLE */}
            <div className="card-body p-12">
                <div className="table-responsive">

                    <table className="table bordered-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>User</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Designation</th>
                                <th>Device</th>
                                <th>Login Time</th>
                            </tr>
                        </thead>

                        <tbody>
                            {userSessions.length === 0 ? (
                                <tr>
                                    <td colSpan="7">
                                        <div className="text-center py-24">
                                            <Icon icon="mdi:alert-circle-outline" width="40" />
                                            <p className="mt-2 text-secondary">No sessions found</p>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                userSessions.map((item, i) => (
                                    <tr key={item.id}>
                                        <td>{(page - 1) * entries + i + 1}</td>

                                        <td className="d-flex align-items-center gap-2">
                                            <Avatar
                                                name={item.user?.fullName}
                                                image={item.user?.profilePicture}
                                                uniqueKey={item.user?.id}
                                                size={28}
                                            />
                                            <span>{truncateText(item.user?.fullName)}</span>
                                        </td>

                                        <td>{truncateText(item.user?.email)}</td>

                                        <td>{truncateText(item.user?.phone) || "-"}</td>

                                        <td>{truncateText(item.user?.designation) || "-"}</td>

                                        <td>

                                            {truncateText(item.deviceName) || "Unknown"}
                                        </td>

                                        <td>
                                            {formatDateTime(item.updatedAt)}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* PAGINATION */}
                <PaginationHelper
                    currentPage={page}
                    totalPages={totalPages}
                    onPageChange={setPage}
                    totalItems={sessionTotal}
                    pageSize={entries}
                />
            </div>
        </div>
    );
};

export default UserSessionLayer;